import { ActivityNamingRule, ActivityNamingRuleType } from 'src/app/domainObjects/transformers/activityNamingTransform';
import { ColoredTextItem, NamedColorList } from 'src/app/domainObjects/coloredTextItem';
import { TransformRuleViewModel } from 'src/app/viewModels/transformRuleViewModel';

export class ActivityNamingRuleViewModel extends TransformRuleViewModel {
    rule: ActivityNamingRule;
    sourceColumn: string;
    targetColumn: string;
    startAt: ActivityNamingRuleType;
    endAt: ActivityNamingRuleType;
    result: string;
    containsList?: ColoredTextItem[];
    includeAfter: number;
    timeoutMs: number;
    andOr: boolean;
    matchCase: boolean;
    
    groupHits?: number;
    rowHits?: number;
    sampleGroupHits?: number;
    sampleRowHits?: number;

    //validation
    tooltipMessageresult:string;
    tooltipTyperesult:string;
    tooltipMessageContains:string;
    tooltipTypeContains:string;

    constructor(rule: ActivityNamingRule) {
      super(rule.ruleId, rule.index, rule.run, rule.ruleName);

      this.sourceColumn = rule.sourceField;
      this.targetColumn = rule.targetField;
      this.startAt = rule.startsAt;
      this.endAt = rule.endsAt;
      this.result = rule.result;
      let colorIndex = 0;
      this.containsList = rule.contains?.map(r => new ColoredTextItem(r, NamedColorList[colorIndex++])) ?? [];
      this.includeAfter = rule.includeAfter;
      this.timeoutMs = rule.timeout;
      this.andOr = rule.andOr;
      this.matchCase = rule.matchCase;
    }

    toRule(): ActivityNamingRule {
      const rule = new ActivityNamingRule();

      rule.index = this.index - 1;
      rule.ruleName = this.name;
      rule.sourceField = this.sourceColumn;
      rule.targetField = this.targetColumn;
      rule.startsAt = this.startAt;
      rule.endsAt = this.endAt;
      rule.result = this.result;
      rule.contains = this.containsList?.map(i => i.text);
      rule.includeAfter = this.includeAfter;
      rule.timeout = this.timeoutMs;
      rule.andOr = this.andOr;
      rule.matchCase = this.matchCase;
      rule.run = this.run;
      return rule;
    }
}
